import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import App from './App'
import { EnvProvider } from './providers/EnvProvider'
import { registerServiceWorker } from './pwa/registerServiceWorker'
import './styles/globals.css'

registerServiceWorker()

const routerBasename = import.meta.env.BASE_URL === '/'
  ? undefined
  : import.meta.env.BASE_URL.replace(/\/$/, '')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter basename={routerBasename}>
      <ConfigProvider locale={zhCN}>
        <EnvProvider>
          <App />
        </EnvProvider>
      </ConfigProvider>
    </BrowserRouter>
  </React.StrictMode>
)
